module.exports = __webpack_public_path__ + "static/media/back14.5f2a2b9a.jpg";